import { Pipe, PipeTransform } from '@angular/core';
import { abbreviateIntentNumber } from '../../helpers';

@Pipe({
  name: 'intentNumberAbbreviator',
  standalone: false
})
export class IntentNumberAbbreviatorPipe implements PipeTransform {
    transform(value: number): string {
        return abbreviateIntentNumber(value);
    }
}
